import { firestore } from "./firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { CustomLunch } from "../@data";

const COLLECTION = "customLunchs";

export const getAllCustomLunchs = async (): Promise<CustomLunch[]> => {
  const snapshot = await getDocs(collection(firestore, COLLECTION));
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() } as CustomLunch));
};

export const getCustomLunchsByDate = async (
  date: string
): Promise<CustomLunch[]> => {
  // Converte a data para timestamp de início e fim do dia no timezone local
  const startOfDay = new Date(date + "T00:00:00");
  const endOfDay = new Date(date + "T23:59:59");

  // Ajusta para o timezone local
  const startOfDayTimestamp =
    startOfDay.getTime() - startOfDay.getTimezoneOffset() * 60000;
  const endOfDayTimestamp =
    endOfDay.getTime() - endOfDay.getTimezoneOffset() * 60000;

  const q = query(
    collection(firestore, COLLECTION),
    where("timestamp", ">=", startOfDayTimestamp),
    where("timestamp", "<=", endOfDayTimestamp)
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() } as CustomLunch));
};

export const getCustomLunchsByProfessionalAndDate = async (
  professionalId: string,
  date: string
): Promise<CustomLunch[]> => {
  // Converte a data para timestamp de início e fim do dia no timezone local
  const startOfDay = new Date(date + "T00:00:00");
  const endOfDay = new Date(date + "T23:59:59");

  // Ajusta para o timezone local
  const startOfDayTimestamp =
    startOfDay.getTime() - startOfDay.getTimezoneOffset() * 60000;
  const endOfDayTimestamp =
    endOfDay.getTime() - endOfDay.getTimezoneOffset() * 60000;

  const q = query(
    collection(firestore, COLLECTION),
    where("professionalId", "==", professionalId),
    where("timestamp", ">=", startOfDayTimestamp),
    where("timestamp", "<=", endOfDayTimestamp)
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() } as CustomLunch));
};
